<template>
  <div class="digital-article-menu" :class="{ 'digital-article-menu-mobile': isMobile }" :style="{ width: width.toString().indexOf('%') === -1 ? width + 'px' : width }" v-if="show">
    <div class="top">
      <div class="txt">{{ module == 'ebook' ? '书刊目录' : '版面文章目录' }}</div>
      <div class="close" @click="close">
        <img src="@imgs/digital/close.png" v-if="!isMobile" />
        <img src="@imgs/digital/close-black.png" v-if="isMobile" />
      </div>
    </div>
    <div class="box" id="digital-article-menu-box" @touchstart="boxTouchstart" @touchmove="boxTouchmove">
      <div class="area" v-if="notRevokeArticles">
        <div class="item" v-for="(page, catalogIndex) in notRevokeArticles" v-bind:key="page.id" :class="{ selected: page.selected }">
          <div class="title">
            <div class="line"></div>
            <div class="text" :class="{ selected: page.page === pageIndex }" @click="changeArticle(page, page.children ? page.children[0] : page, catalogIndex + 1, 0,page.xiaoYangId ? 2 : 1)">
              {{ page.label }}
            </div>
          </div>
          <div class="list">
            <div
                class="text"
                v-for="(article, index) in page.children"
                v-bind:key="index"
                :class="{ selected: index== articleIndex && page.page === pageIndex }"
                @click="changeArticle(page, article, catalogIndex + 1, index, 2)"
            >
              {{ article.label }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DigitalArticleMenu',
  components: {},
  props: {
    width: {
      type: [Number, String],
      default: 300
    },
    articles: {
      type: Array,
      default: () => {
        return []
      }
    },
    initShow: {
      type: Boolean,
      default: false
    },
    initPageIndex: {
      type: Number,
      default: 1
    },
    initArticleIndex: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      show: this.initShow,
      pageIndex: this.initPageIndex, // 页面当前索引（从1开始）
      articleIndex: this.initArticleIndex, // 文章当前索引（从1开始）,
      box: null,
      boxY: 0,
      boxTouchY: 0,
      module: staticOptions.module //epaper:数字报  ebook:书刊
    }
  },
  watch: {
    initShow(show) {
      this.show = show
    },
    initPageIndex(pageIndex) {
      this.pageIndex = pageIndex
    },
    initArticleIndex(articleIndex) {
      this.articleIndex = articleIndex
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.book.isMobile
    },
    notRevokeArticles() {
      return this.articles.filter((item) => !item.revokeStatus)
    },
  },
  methods: {
    boxTouchstart(e) {
      this.box = document.getElementById('digital-article-menu-box')
      this.boxY = this.box.scrollTop
      this.boxTouchY = e.touches[0].pageY
    },
    boxTouchmove(e) {
      this.box.scrollTop = this.boxTouchY - e.touches[0].pageY + this.boxY
    },
    changeArticle(page, article, pageIndex, articleIndex, optype) {
      this.pageIndex = parseInt(page.page)
      this.articleIndex = parseInt(articleIndex)
      this.$emit('onChangeArticle', page, article, parseInt(pageIndex), parseInt(articleIndex), optype)
    },
    close() {
      this.show = false
      this.$emit('onClose')
    }
  }
}
</script>
<style lang="scss">
.digital-article-menu {
  position: absolute;
  left: 0;
  top: 0;
  width: 300px;
  height: 100%;
  background: #ffffff;
  z-index: 999;
  .top {
    position: relative;
    background: #df5813;
    .txt {
      display: block;
      width: 100%;
      line-height: 40px;
      text-align: center;
      color: #ffffff;
      font-weight: bold;
      font-size: 16px;
    }
    .close {
      position: absolute;
      top: 0;
      right: 0;
      width: 40px;
      height: 40px;
      text-align: center;
      cursor: pointer;
      img {
        margin-top: 13px;
        width: 14px;
        height: 14px;
      }
    }
  }
  .box {
    height: calc(100% - 40px);
    overflow: auto;
    .area {
      .item {
        font-size: 16px;
        padding-top: 10px;
        border-bottom: 5px solid #e3e3e3;
        &:last-child {
          border-bottom: none;
        }
        .title {
          position: relative;
          .line {
            position: absolute;
            background: red;
            left: 20px;
            top: 14px;
            width: 3px;
            height: 16px;
          }
          .text {
            font-weight: bold;
            line-height: 24px;
            padding: 10px 31px 10px 34px;
            cursor: pointer;
            &:hover {
              background: #f3f3f3;
            }
            &:active {
              background: #e3e3e3;
            }
          }
          .selected {
            background: #e3e3e3;
          }
        }
        .list {
          .text {
            line-height: 24px;
            padding: 10px 31px 10px 34px;
            border-bottom: 1px solid #f3f3f3;
            cursor: pointer;
            &:last-child {
              border-bottom: none;
            }
            &:hover {
              background: #f3f3f3;
            }
            &:active {
              background: #e3e3e3;
            }
          }
          .selected {
            background: #e3e3e3;
          }
        }
      }
    }
  }
}
.digital-article-menu-mobile {
  z-index: 9998;
  .top {
    background: #f5f5f5;
    .txt {
      color: #3a3a3a;
    }
  }
}
</style>
